module.exports = __webpack_public_path__ + "img/Peggy_Binzel.232ba855.jpg";